import ProductCollectionPage from "../common/ProductCollectionPage";

const Suits = ({ onAddToCart }) => (
  <ProductCollectionPage
    seo={{
      title: "Suits",
      description: "Shop suits on Emporia, a Kenyan online marketplace. Pay securely with M-Pesa and get delivery across Kenya.",
      path: "/suits",
    }}
    query="category=suits"
    eyebrow="Collection"
    heading="Suits"
    tagline="Tailored excellence for every occasion — from boardroom to black tie."
    onAddToCart={onAddToCart}
  />
);

export default Suits;
